import { enhancedApi } from './codegen.api';

export const reportApi = enhancedApi.enhanceEndpoints({});

export const { useStatisticsRetrieveQuery, useStatisticsChartListQuery } = reportApi;
